// Use binary search to find the index of insertion for a number into an ordered array of numbers
function insertionIndex(arr, target) {
  let low = 0;
  let high = arr.length;

  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (arr[mid] < target) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }

  return low;
}

export default insertionIndex;
